import React, { useEffect, useState } from "react";
import { useDocumentTitle } from "../../Hooks/useDocumentTitle";
import { Footer } from "../../Components/Footer";

import {
  Box,
  Button,
  CardMedia,
  Container,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Modal,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

import { useParams } from "react-router-dom";

import moment from "moment";

import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import LinkZoneWithCopyButton from "../../Components/CopyLinkButton";

import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import EventAvailableRoundedIcon from "@mui/icons-material/EventAvailableRounded";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import PublicRoundedIcon from "@mui/icons-material/PublicRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import FactCheckRoundedIcon from "@mui/icons-material/FactCheckRounded";
import ValidateBadgeFake from "../../Components/validateBadgeFake";

import userService from "../../Actions/services";



export default function PublicBadge() {
  useDocumentTitle("Odznaka");

  const { slug } = useParams();

  const [badge, setBadge] = useState(null);
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };


  useEffect(() => {
    if (!slug) return;

    userService
      .getPublicBadge(slug)
      .then((res) => {
        setBadge(res.data);
      })
      .catch((error) => {
        console.error(
          "Błąd podczas pobierania odznaki:",
          error
        );
      });
  }, [slug]);


  const badgeData = badge?.attributes || badge;

  const badgeImage =
    badge?.attributes?.image?.data?.attributes?.url ||
    badge?.image?.url ||
    "";

  const badgeName =
    badgeData?.badgeName ||
    "Mikropoświadczenie";

  const description =
    badgeData?.description ||
    badgeData?.desc ||
    "";

  const issuanceDate =
    badgeData?.issuanceDate || null;

  const examExpiryDate =
    badgeData?.exam_expiry_date || null;

  const expirationDate =
    badgeData?.expirationDate || null;

  const badgeType =
    badgeData?.badgeType || "";

  const issuer =
    badgeData?.issuer || "";

  const qualificationName =
    badgeData?.qualificationName || "";

  const isTraining =
    badgeData?.szkolenie === true;

  const learningEffects =
    badgeData?.learningEffects?.learningEffects || [];

  const badgeSlug =
    badgeData?.slug || slug;

  const publicBadgeUrl =
    `${process.env.REACT_APP_MEDIA_URL}/public-badge/${badgeSlug}`;

  const badgeUser =
    badgeData?.user || null;

  const holderName = badgeUser
    ? `${badgeUser.firstname || ""} ${badgeUser.lastname || ""}`.trim()
    : "";


  const badgeSets =
    badgeData
      ?.badge_model_reference
      ?.data
      ?.attributes
      ?.sets
      ?.data || [];


  useEffect(() => {
    if (!badge) return;

    const setMeta = (property, content) => {
      let meta = document.querySelector(
        `meta[property="${property}"]`
      );

      if (!meta) {
        meta = document.createElement("meta");

        meta.setAttribute(
          "property",
          property
        );

        document.head.appendChild(meta);
      }

      meta.setAttribute(
        "content",
        content || ""
      );
    };

    setMeta(
      "og:title",
      badgeName
    );

    setMeta(
      "og:description",
      description ||
      "Mikropoświadczenie potwierdzające zdobyte kompetencje."
    );

    setMeta(
      "og:url",
      window.location.href
    );

    setMeta(
      "og:type",
      "website"
    );

    setMeta(
      "og:image",
      'https://vcc-strapi-bucket.s3.eu-north-1.amazonaws.com/Desery1_555d3cd945.png'
      // badge?.badge_model_reference?.attributes?.image?.data?.attributes?.url
      // badgeImage
    );

  }, [
    badge,
    badgeName,
    description,
    badgeImage,
  ]);


  const CutText = (text, maxWords) => {
    if (!text) return "";

    const words = text.split(" ");

    if (words.length <= maxWords) {
      return text;
    }

    return (
      words
        .slice(0, maxWords)
        .join(" ") + "..."
    );
  };


  const InfoRow = ({
    icon,
    label,
    children,
  }) => (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        alignItems: "center",
        py: 1.7,
        borderBottom: "1px solid",
        borderColor:
          "rgba(17, 51, 75, 0.08)",
        "&:last-child": {
          borderBottom: 0,
        },
      }}
    >
      <Box
        sx={{
          width: 42,
          height: 42,
          minWidth: 42,
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor:
            "rgba(108, 198, 217, 0.13)",
          color: "#11334b",
        }}
      >
        {icon}
      </Box>

      <Box
        sx={{
          minWidth: 0,
          flex: 1,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            display: "block",
            color: "text.secondary",
            fontWeight: 600,
            mb: 0.3,
          }}
        >
          {label}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: "#11334b",
            fontWeight: 700,
            lineHeight: 1.4,
            wordBreak: "break-word",
          }}
        >
          {children}
        </Typography>
      </Box>
    </Box>
  );


  if (!badge) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography color="text.secondary">
          Ładowanie mikropoświadczenia...
        </Typography>
      </Box>
    );
  }


  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          py: {
            xs: 3,
            md: 6,
          },
          // background:
          //   "linear-gradient(180deg, #f4f8fa 0%, #ffffff 55%, #f7fafb 100%)",
        }}
      >
        <Container maxWidth="lg">

          <Box
            sx={{
              textAlign: "center",
              mb: {
                xs: 3,
                md: 5,
              },
            }}
          >
            <Typography
              component="h1"
              sx={{
                fontSize: {
                  xs: "2rem",
                  sm: "2.5rem",
                  md: "3rem",
                },
                fontWeight: 800,
                letterSpacing: "-0.035em",
                lineHeight: 1.15,
                color: "#11334b",
              }}
            >
              {badgeName}
            </Typography>
          </Box>

          <Paper
            elevation={0}
            sx={{
              overflow: "hidden",
              borderRadius: {
                xs: 3,
                md: 5,
              },
              border:
                "1px solid rgba(17, 51, 75, 0.08)",
              boxShadow:
                "0 25px 70px rgba(17, 51, 75, 0.10)",
              backgroundColor: "#ffffff",
            }}
          >

            <Grid container>

              <Grid
                item
                xs={12}
                md={5}
                sx={{
                  position: "relative",
                  minHeight: {
                    xs: 400,
                    md: 650,
                  },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  p: {
                    xs: 4,
                    md: 6,
                  },
                  overflow: "hidden",
                  background: "#294e6b",
                }}
              >


                {[
                  {
                    top: "6%",
                    left: "7%",
                    size: 190,
                    rotate: "-12deg",
                  },
                  {
                    top: "6%",
                    right: "7%",
                    size: 190,
                    rotate: "12deg",
                  },
                  {
                    top: "38%",
                    left: "-5%",
                    size: 180,
                    rotate: "10deg",
                  },
                  {
                    top: "38%",
                    right: "-5%",
                    size: 180,
                    rotate: "-10deg",
                  },
                  {
                    bottom: "6%",
                    left: "7%",
                    size: 190,
                    rotate: "12deg",
                  },
                  {
                    bottom: "6%",
                    right: "7%",
                    size: 190,
                    rotate: "-12deg",
                  },
                  {
                    top: "20%",
                    left: "38%",
                    size: 155,
                    rotate: "8deg",
                  },
                  {
                    bottom: "18%",
                    right: "38%",
                    size: 155,
                    rotate: "-8deg",
                  },
                ].map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      position: "absolute",
                      top: item.top,
                      bottom: item.bottom,
                      left: item.left,
                      right: item.right,
                      width: item.size,
                      height: item.size,
                      transform: `rotate(${item.rotate})`,
                      opacity: 0.22,
                      filter: "blur(1px)",
                      zIndex: 0,

                      "& img": {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      },
                    }}
                  >
                    {badgeImage && (
                      <img
                        src={badgeImage}
                        alt=""
                      />
                    )}
                  </Box>
                ))}

                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "radial-gradient(circle at center, rgba(41,78,107,0.35) 0%, rgba(41,78,107,0.72) 55%, rgba(41,78,107,0.96) 100%)",
                    zIndex: 1,
                  }}
                />

                <Box
                  sx={{
                    position: "relative",
                    zIndex: 3,
                    width: "100%",
                    maxWidth: 420,
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {badgeImage && (
                    <img
                      src={badgeImage}
                      alt={badgeName}
                      style={{
                        display: "block",
                        width: "100%",
                        height: "auto",
                        borderRadius: "18px",
                      }}
                    />
                  )}
                </Box>

              </Grid>

              <Grid
                item
                xs={12}
                md={7}
                sx={{
                  p: {
                    xs: 3,
                    sm: 4,
                    md: 5,
                  },
                }}
              >

                {description && (
                  <Box
                    sx={{
                      mb: 4,
                      p: 3,
                      borderRadius: 3,
                      background:
                        "linear-gradient(135deg, rgba(17,51,75,0.04), rgba(108,198,217,0.10))",
                    }}
                  >
                    <Typography
                      component="h2"
                      sx={{
                        fontSize: {
                          xs: "1.15rem",
                          md: "1.35rem",
                        },
                        lineHeight: 1.55,
                        color: "#11334b",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {description}
                      </span>
                    </Typography>
                  </Box>
                )}

                <Typography
                  variant="overline"
                  sx={{
                    color: "#16809a",
                    fontWeight: 800,
                    letterSpacing: "0.12em",
                  }}
                >
                  INFORMACJE O ODZNACE
                </Typography>


                <Paper
                  elevation={0}
                  sx={{
                    mt: 1,
                    px: 2,
                    borderRadius: 3,
                    border:
                      "1px solid rgba(17,51,75,0.08)",
                  }}
                >

                  {issuanceDate && (
                    <InfoRow
                      icon={
                        <CalendarMonthRoundedIcon fontSize="small" />
                      }
                      label="Data wystawienia:"
                    >
                      {moment(
                        issuanceDate
                      ).format("LL")}
                    </InfoRow>
                  )}

                  <InfoRow
                    icon={
                      <SchoolRoundedIcon fontSize="small" />
                    }
                    label={`Data ${isTraining
                      ? "ukończenia szkolenia"
                      : "egzaminu"
                      }:`}
                  >
                    {examExpiryDate
                      ? moment(
                        examExpiryDate
                      ).format("LL")
                      : "—"}
                  </InfoRow>

                  <InfoRow
                    icon={
                      <EventAvailableRoundedIcon fontSize="small" />
                    }
                    label="Data wygaśnięcia:"
                  >
                    {expirationDate
                      ? moment(
                        expirationDate
                      ).format("LL")
                      : "bezterminowo"}
                  </InfoRow>


                  {holderName && (
                    <InfoRow
                      icon={
                        <VerifiedRoundedIcon fontSize="small" />
                      }
                      label="Posiadacz:"
                    >
                      {holderName}
                    </InfoRow>
                  )}


                  <InfoRow
                    icon={
                      <BusinessRoundedIcon fontSize="small" />
                    }
                    label="Instytucja wystawiająca:"
                  >
                    <b>Fundacja VCC</b>
                    {issuer && (
                      <span>
                        {" "}
                        {issuer}
                      </span>
                    )}
                  </InfoRow>


                  <InfoRow
                    icon={
                      <PublicRoundedIcon fontSize="small" />
                    }
                    label="Kraj wystawcy:"
                  >
                    <b>Polska</b>
                  </InfoRow>


                  {badgeType && (
                    <InfoRow
                      icon={
                        <WorkspacePremiumRoundedIcon fontSize="small" />
                      }
                      label="Rodzaj odznaki:"
                    >
                      {badgeType}
                    </InfoRow>
                  )}


                  {qualificationName && (
                    <InfoRow
                      icon={
                        <FactCheckRoundedIcon fontSize="small" />
                      }
                      label="Kwalifikacja:"
                    >
                      {qualificationName}
                    </InfoRow>
                  )}

                </Paper>


                {learningEffects.length > 0 && (
                  <Box sx={{ mt: 5 }}>

                    <Typography
                      variant="overline"
                      sx={{
                        color: "#16809a",
                        fontWeight: 800,
                        letterSpacing: "0.12em",
                      }}
                    >
                      EFEKTY UCZENIA SIĘ:
                    </Typography>

                    <Paper
                      elevation={0}
                      sx={{
                        mt: 1,
                        p: 2,
                        borderRadius: 3,
                        backgroundColor:
                          "#f8fafb",
                        border:
                          "1px solid rgba(17,51,75,0.08)",
                      }}
                    >

                      <List sx={{ p: 0 }}>

                        {learningEffects.map(
                          (item, i) => (
                            <ListItem
                              key={i}
                              sx={{
                                px: 1,
                                py: 1.2,
                                alignItems:
                                  "flex-start",
                                "&:not(:last-child)":
                                {
                                  borderBottom:
                                    "1px solid rgba(17,51,75,0.06)",
                                },
                              }}
                            >

                              <ListItemIcon
                                sx={{
                                  minWidth: 32,
                                  mt: 0.5,
                                }}
                              >
                                <ChevronRightIcon
                                  sx={{
                                    color: "#16809a",
                                  }}
                                />
                              </ListItemIcon>

                              <ListItemText
                                primary={
                                  item.effectName
                                }
                                primaryTypographyProps={{
                                  fontSize:
                                    "0.95rem",
                                  lineHeight:
                                    1.55,
                                  fontWeight: 500,
                                  color:
                                    "#263238",
                                }}
                              />

                            </ListItem>
                          )
                        )}

                      </List>

                    </Paper>

                  </Box>
                )}


                <Box sx={{ mt: 4 }}>
                  <LinkZoneWithCopyButton
                    slug={badgeSlug}
                  />
                </Box>



                <Stack
                  direction={{
                    xs: "column",
                    sm: "row",
                  }}
                  spacing={2}
                  sx={{
                    mt: 4,
                  }}
                >


                  <Button
                    fullWidth
                    variant="contained"
                    startIcon={
                      <VerifiedRoundedIcon />
                    }
                    onClick={() =>
                      setShow(true)
                    }
                    sx={{
                      flex: 1,
                      minHeight: 52,
                      borderRadius:
                        "14px",
                      px: 3,
                      textTransform:
                        "none",
                      fontWeight: 800,
                      background:
                        "linear-gradient(135deg, #11334b, #16809a)",
                      boxShadow:
                        "0 8px 20px rgba(17,51,75,0.18)",
                      "&:hover":
                      {
                        background:
                          "linear-gradient(135deg, #0d2b3e, #116f85)",
                        boxShadow:
                          "0 12px 28px rgba(17,51,75,0.24)",
                      },
                    }}
                  >
                    Weryfikuj
                  </Button>

                </Stack>


                <Modal
                  open={show}
                  onClose={handleClose}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent:
                      "center",
                    p: 2,
                  }}
                >
                  <ValidateBadgeFake setShow={setShow} />
                </Modal>


              </Grid>

            </Grid>

            {badgeSets.length > 0 && (
              <Box
                sx={{
                  p: {
                    xs: 3,
                    md: 5,
                  },
                  borderTop:
                    "1px solid rgba(17,51,75,0.08)",
                  backgroundColor:
                    "#fafcfd",
                }}
              >

                <Typography
                  variant="overline"
                  sx={{
                    color: "#16809a",
                    fontWeight: 800,
                    letterSpacing:
                      "0.12em",
                  }}
                >
                  POWIĄZANE ODZNAKI
                </Typography>


                <Grid
                  container
                  spacing={2}
                  sx={{
                    mt: 1,
                  }}
                >

                  {badgeSets.map(
                    (set, i) => {
                      const setImage =
                        set
                          ?.attributes
                          ?.image
                          ?.data
                          ?.attributes
                          ?.url ||
                        "";

                      const setName =
                        set
                          ?.attributes
                          ?.badgeName ||
                        "";

                      return (
                        <Grid
                          key={
                            set?.id ||
                            i
                          }
                          item
                          xs={6}
                          sm={4}
                          md={3}
                        >
                          <Paper
                            elevation={
                              0
                            }
                            sx={{
                              height:
                                "100%",
                              p: 2,
                              textAlign:
                                "center",
                              borderRadius:
                                3,
                              backgroundColor:
                                "#fff",
                              border:
                                "1px solid rgba(17,51,75,0.07)",
                              transition:
                                "transform .2s, box-shadow .2s",
                              "&:hover":
                              {
                                transform:
                                  "translateY(-4px)",
                                boxShadow:
                                  "0 12px 30px rgba(17,51,75,0.10)",
                              },
                            }}
                          >

                            <Typography
                              variant="caption"
                              sx={{
                                display:
                                  "block",
                                minHeight:
                                  39,
                                fontWeight:
                                  700,
                                color:
                                  "#11334b",
                              }}
                            >
                              {CutText(
                                setName,
                                7
                              )}
                            </Typography>


                            <Box
                              sx={{
                                mt: 1,
                                height: 130,
                                display:
                                  "flex",
                                alignItems:
                                  "center",
                                justifyContent:
                                  "center",
                              }}
                            >
                              {setImage && (
                                <img
                                  src={
                                    setImage
                                  }
                                  alt={
                                    setName
                                  }
                                  style={{
                                    width:
                                      "75%",
                                    maxHeight:
                                      "120px",
                                    objectFit:
                                      "contain",
                                  }}
                                />
                              )}
                            </Box>

                          </Paper>
                        </Grid>
                      );
                    }
                  )}

                </Grid>

              </Box>
            )}

          </Paper>

        </Container>

      </Box>

      {/* <Footer /> */}
    </>
  );
}



// import React, { useEffect, useState } from "react";
// import { useDocumentTitle } from "../../Hooks/useDocumentTitle";
// import { Footer } from "../../Components/Footer";
// import {
//   Box,
//   Button,
//   Chip,
//   Container,
//   Grid,
//   List,
//   ListItem,
//   ListItemText,
//   Modal,
//   Paper,
//   Stack,
//   Typography,
//   styled,
// } from "@mui/material";
// import { Link, useParams } from "react-router-dom";
// import { getBadges } from "../../Slices/badges";
// import { useDispatch, useSelector } from "react-redux";
// import { createSelector } from "reselect";
// import axios from "axios";
// import ValidateBadge from "../../Components/validateBadge";
// import moment from "moment";
// import {
//   EmailShareButton,
//   FacebookShareButton,
//   InstapaperShareButton,
//   LinkedinShareButton,
//   PinterestShareButton,
//   RedditShareButton,
//   TwitterShareButton,
//   ViberShareButton,
//   WhatsappShareButton,
// } from "react-share";
// import FacebookIcon from "@mui/icons-material/Facebook";
// import EmailIcon from "@mui/icons-material/Email";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
// import XIcon from "@mui/icons-material/X";
// import userService from "../../Actions/services";
// import ValidateBadgeFake from "../../Components/validateBadgeFake";

// export default function PublicBadge() {
//   useDocumentTitle("Odznaka ");
//   let { slug } = useParams();
//   const [badge, setBadge] = useState();
//   const [show, setShow] = useState(false);

//   const handleClose = () => {
//     setShow(false);
//   };

//   const handleShow = () => setShow(true);

//   useEffect(() => {
//     userService.getPublicBadge(slug).then((res) => {
//       console.log('res', res)
//       setBadge(res.data)
//     });
//   }, [slug]);

//   //   const selectBadge = createSelector(
//   //     (state) => state.badges,
//   //     (badges) => badges.filter((badge) => badge.id === Number(badgeId))[0]
//   //   );
//   //   const badge = useSelector(selectBadge);


//   const CutText = (text, maxWords) => {
//     const words = text.split(" ");

//     if (words.length <= maxWords) {
//       return text;
//     } else {
//       const truncatedWords = words.slice(0, maxWords);
//       return truncatedWords.join(" ") + "...";
//     }
//   };

//   return (
//     <>
//       {badge && (
//         <Container>
//           <Grid item xs={12}>
//             <Grid container spacing={0}>
//               <Grid item xs={12}>
//                 <Typography
//                   component="h1"
//                   variant="h4"
//                   align="center"
//                   color="text.primary"
//                   sx={{ marginY: "40px" }}
//                 >
//                   {badge.badgeName}
//                 </Typography>
//               </Grid>

//               <Grid container spacing={8}>
//                 <Grid item xs={12} md={5} sx={{ textAlign: "center" }}>
//                   <img
//                     // src={`${process.env.REACT_APP_STRAPI_MEDIA}${badge.attributes.image.data.attributes.url}`}
//                     src={badge.image.url}
//                     alt="badge"
//                     style={{ width: "90%", marginTop: "20px" }}
//                   />
//                 </Grid>
//                 <Grid item xs={12} md={7}>
//                   <Typography
//                     component="h2"
//                     variant="h5"
//                     sx={{
//                       marginBottom: "50px",
//                       textAlign: {
//                         xs: "center",
//                         md: "left",
//                       },
//                     }}
//                   >
//                     <span style={{ fontWeight: "bold" }}>
//                       {badge.description}
//                     </span>
//                   </Typography>
//                   <Box>
//                     <Typography component="h4" variant="subtitle1">
//                       Data wystawienia:{" "}
//                       <span style={{ fontWeight: "bold" }}>
//                         {moment(badge.issuanceDate).format("LL")}
//                       </span>
//                     </Typography>
//                     {console.log(badge)}
//                     <Typography component="h4" variant="subtitle1">
//                       Data {badge.szkolenie === true ? "ukończenia szkolenia" : "egzaminu"}:{" "}
//                       <span style={{ fontWeight: "bold" }}>
//                         {badge.exam_expiry_date
//                           ? moment(badge.exam_expiry_date).format(
//                             "LL"
//                           )
//                           : ""}
//                       </span>
//                     </Typography>
//                     <Typography component="h4" variant="subtitle1">
//                       Data wygaśnięcia:{" "}
//                       <span style={{ fontWeight: "bold" }}>
//                         {badge.expirationDate
//                           ? moment(badge.expirationDate).format("LL")
//                           : "bezterminowo"}
//                       </span>
//                     </Typography>
//                     {/* <Typography component="h4" variant="subtitle1">
//                       Instytucja wystawiająca:{" "}
//                       <span style={{ fontWeight: "bold" }}>
//                         {badge.attributes.issuer}
//                       </span>
//                     </Typography> */}
//                     <Typography component="h4" variant="subtitle1">
//                       Posiadacz:{" "}
//                       <span style={{ fontWeight: "bold" }}>
//                         {`${badge.user.firstname} ${badge.user.lastname}`}
//                       </span>
//                     </Typography>
//                     <Typography component="h4" variant="subtitle1">
//                       Rodzaj odznaki:{" "}
//                       <span style={{ fontWeight: "bold" }}>
//                         {badge.badgeType}
//                       </span>
//                     </Typography>
//                     <Typography component="h4" variant="subtitle1">
//                       Instytucja wystawiająca: {<b>Fundacja VCC</b>}
//                       <span style={{ fontWeight: "bold" }}>
//                         {badge?.issuer}
//                       </span>
//                     </Typography>
//                     <Typography component="h4" variant="subtitle1">
//                       Kraj wystawcy: {<b>Polska</b>}
//                       <span style={{ fontWeight: "bold" }}>
//                         {badge?.issuer}
//                       </span>
//                     </Typography>
//                     {badge?.qualificationName &&
//                       <Typography component="h4" variant="subtitle1">
//                         Kwalifikacja:{" "}
//                         <span style={{ fontWeight: "bold" }}>
//                           {badge?.qualificationName}
//                         </span>
//                       </Typography>
//                     }
//                   </Box>
//                   <Box sx={{ marginTop: "40px" }}>
//                     <Typography component="h4" variant="subtitle1">
//                       EFEKTY UCZENIA SIĘ:
//                       <List>
//                         {badge.learningEffects?.learningEffects.map((item) => (
//                           <ListItem sx={{ padding: 0 }}>
//                             <ListItemText primary={item.effectName} />
//                           </ListItem>
//                         ))}
//                       </List>
//                     </Typography>
//                   </Box>
//                   {/* <a href={badge.image.url}>
//                     <Button
//                       variant="outlined"
//                       sx={{
//                         mt: 4,
//                         padding: "15px 32px",
//                         backgroundColor: "#ed6c0217",
//                       }}
//                     >
//                       Pobierz mikropoświadczenie
//                     </Button>
//                   </a> */}
//                   {/* Fake pod prezentacje */}
//                   <Button
//                     variant="outlined"
//                     sx={{
//                       mt: 4,
//                       ml: 2,
//                       padding: "15px 32px",
//                       backgroundColor: "#ed6c0217",
//                     }}
//                     onClick={() => setShow(true)}
//                   >
//                     Weryfikuj
//                   </Button>
//                   <Modal
//                     open={show}
//                     onClose={handleClose}
//                     sx={{
//                       justifyContent: "center",
//                       height: "100vh",
//                       alignContent: "center",
//                     }}
//                   >
//                     <ValidateBadgeFake setShow={setShow} />
//                   </Modal>
//                 </Grid>
//               </Grid>
//             </Grid>
//           </Grid>
//         </Container>
//       )}
//       {/* <Footer /> */}
//     </>
//   );
// }
